import angular = require("angular");

import TPL = require("templates");
import {Config} from "../../config";
import {Covers} from "../../models/data";

declare var FB: any;

export class SocialShareDirective {

  template = TPL.commonDirectives.socialShare;
  scope = {
    params: "=params"
  };

  link;
  facebook;
  session;
  shortUrl;
  isloading = false;
  shortUrlEventId;

  constructor(session, rootScope, window, $log) {

    this.link = (scope, el, attrs) => {
        scope.vm = {
          getEventType: () => {
            var currentEvent = session.data.event;
            if(currentEvent != null) {
              return currentEvent.event_type;
            } else {
              return null;
            }
          },

          getUrlShortener: (eventId?) => {
            var searchEventId;
            if(eventId) {
              searchEventId = eventId;
            } else {
              var currentEvent = session.data.event;
              if(currentEvent != null) {
                searchEventId = currentEvent.uuid;
              }
            }

            if(searchEventId != null && searchEventId != this.shortUrlEventId && !this.isloading) {
              var eventUrl = Config.publicEndpoint + '#' + Config.events + '/' + searchEventId
              this.isloading = true;
              session.shortenUrl(eventUrl).then((response) => {
                this.shortUrl = response.data.id;
                this.isloading = false;
                this.shortUrlEventId = searchEventId;
              });
            }

            return this.shortUrl;
          },

          shareOnTwitter: () => {
            var url = scope.vm.getUrlShortener();
            var encodedUrl = window.encodeURI(url);
            var twitterBaseUrl = "https://twitter.com/intent/tweet?text=" + encodedUrl;
            var newwindow = window.open(twitterBaseUrl,'name','height=397,width=550');
	          if (window.focus) {newwindow.focus()}
          },

          shareOnFacebook: () => {
            $log.debug("share on facebook");
            $log.debug(FB);

            var currentEvent = session.data.event;
            var eventURL = Config.publicEndpoint + '#' + Config.events + '/' + currentEvent.uuid
            $log.debug("eventURL: " + eventURL);

            var currentEventPhoto = Config.publicEndpoint + 'assets/bannerless.jpg';

            if(currentEvent.cover) {

              currentEventPhoto = currentEvent.cover.m;
            }

            try {
              FB.ui({
                  display: 'popup',
                  method: 'feed',
                  link: eventURL,
                  title: currentEvent.title,
                  picture: currentEventPhoto,
                  description: currentEvent.description,
                  caption: 'Powered by BBYO'
              }, function(response){
                $log.debug("response: " + response);
                rootScope.$broadcast("share_done");
              });
            } catch(err) {
              $log.debug("err: " + err);
            }
          },
        }
    };
  }

  static factory() {
    var tmp = (a, b, c, d) => new SocialShareDirective(a, b, c, d);
    tmp.$inject = ["session", "$rootScope", "$window", "$log"];
    return tmp;
  }

}



/** WEBPACK FOOTER **
 ** ./src/scripts/directives/common/socialShare.ts
 **/